import React, { useMemo, useRef, useState } from 'react';
import { graphql } from 'gatsby';
import WithSection from '../../components/WithSection/WithSection';
import {
    Body1,
    Body2,
    Head3,
    Headline,
} from '../../components/Typography/Typography';
import Box from '../../components/Box/Box';
import Image from '../../components/Image/Image';
import PrismicLink from '../../components/PrismicLink/PrismicLink';
import useViewport from '../../hooks/useViewport';
import TabsGroup from '../../components/TabsGroup/TabsGroup';
import Carousel from '../../components/Carousel/Carousel';
import Stack from '../../components/Stack/Stack';
import Button from '../../components/Button/Button';
import { IoIosArrowForward } from 'react-icons/io';
import { rem } from 'polished';
import { css } from 'styled-components';
import { theme } from '../../../config/theme';

const IconWrapper = ({ image, ...props }) => (
    <Box
        display="inline-grid"
        placeItems="center"
        width={rem(124)}
        height={rem(124)}
        backgroundColor="primary.100"
        borderRadius="full"
        border={`4px solid ${theme.colors.primary[200]}`}
        css={css`
            img {
                user-select: none;
            }
        `}
    >
        {image}
    </Box>
);

const GridSection = ({ data: { primary, items } }) => {
    return (
        <Box gridColumn={{ _: '1/-1', lg: '2/-2' }}>
            <Box marginBottom={rem('48px')}>
                <Head3 bold textAlign={['center']} py={rem(8)}>
                    {primary?.heading.text}
                </Head3>
                {primary?.subheading && (
                    <Body1
                        marginTop={rem('4px')}
                        py={rem(8)}
                        textAlign={['center']}
                    >
                        {primary?.subheading}
                    </Body1>
                )}
            </Box>
            <Box
                display="grid"
                gridTemplateColumns={{
                    _: '1fr',
                    sm: `repeat(3, minmax(0, 1fr))`,
                }}
                gridRowGap={['65px', null, '33px', '50px']}
                gridColumnGap="25px"
                justifyContent="space-between"
            >
                {items.map(
                    ({ title, description, image, text_link, link }, i) => (
                        <Box
                            key={i}
                            display="grid"
                            alignContent="start"
                            justifyItems={'center'}
                            textAlign={'center'}
                        >
                            <Box marginBottom="5px" width={'200px'}>
                                <IconWrapper
                                    image={
                                        <Image
                                            height="48px"
                                            width="48px"
                                            objectPosition="bottom"
                                            img={image}
                                        />
                                    }
                                />
                            </Box>
                            {title && (
                                <Body1 marginBottom="8px" bold>
                                    {title.text}
                                </Body1>
                            )}

                            <Body2>{description}</Body2>
                            {text_link && (
                                <PrismicLink
                                    link={link}
                                    variant="secondary"
                                    marginTop="8px"
                                >
                                    {text_link}
                                </PrismicLink>
                            )}
                        </Box>
                    )
                )}
            </Box>
        </Box>
    );
};

// TODO: convert to fragments
export const _ = graphql`
    fragment GRID_SECTION on PrismicFeatureListDefault {
        primary {
            heading {
                text
            }
            subheading
        }
        items {
            title {
                text
            }
            description
            text_link
            link {
                ...PRISMIC_LINK_FRAGMENT
            }
            image {
                gatsbyImageData(layout: CONSTRAINED, height: 130)
                alt
                url
            }
        }
    }
`;
export default WithSection(GridSection);
